module.exports = __webpack_public_path__ + "img/avatar.76a75b8f.png";